module.exports = __webpack_public_path__ + "static/media/01.5449d795.png";